module.exports = __webpack_public_path__ + "img/kr-product-intl-card4-img1.744daa7.png";